export const ENVIRONMENT = 'prod';
export const DOMAIN = 'streambank.com';
export const SBM_VERSION = '2.2.3 (Jul 7, 2025)';

//keyboard values
export const SB_ENTER_KEY_CODE = 13;
export const SB_ESC_KEY_CODE = 27;